<template>
  <div
    class="ribbon py-12"
    :class="[
      { 'bg-primary text-white': variant === 'primary' },
      { 'bg-gray-6 text-primary': variant === 'gray' },
    ]"
  >
    <div
      class="lg:max-w-7xl flex flex-col items-center md:flex-row md:justify-between mx-auto px-8"
    >
      <div class="text-block text-center mb-8 md:mb-0 md:text-left">
        <TypeHeading
          :variant="$options.Typography.Heading.HEADLINE"
          :weight="$options.Typography.Weights.REGULAR"
          tag="p"
          >{{ subtitle }}</TypeHeading
        >
        <TypeDisplay
          :variant="$options.Typography.Display.TERA"
          :weight="$options.Typography.Weights.STRONG"
          tag="p"
          >{{ title }}</TypeDisplay
        >
      </div>
      <BaseButton
        variant="secondary"
        size="large"
        pre-icon="phone"
        @click="$router.push(to)"
      >
        {{ cta }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {
  constants,
  BaseButton,
  TypeDisplay,
  TypeHeading,
} from '@bambeehr/pollen';
import { defineComponent } from '@nuxtjs/composition-api';

const { Typography } = constants;
export default defineComponent({
  name: 'Ribbon',
  Typography,
  components: { BaseButton, TypeDisplay, TypeHeading },
  props: {
    title: {
      type: String,
      default: 'Schedule an Overview Call',
    },
    subtitle: {
      type: String,
      default: 'Learn how Bambee can help your business',
    },
    cta: {
      type: String,
      default: 'Schedule Overview Call',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    to: {
      type: String,
      default: '/registration/company-size',
    },
  },
});
</script>
